





























import { defineComponent } from '@vue/composition-api';

const name = 'ttam-product-source-shop-alert';
export default defineComponent({
  name,
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isShopAdmin: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
